import React, { useContext, useEffect, useState } from "react";
import { Plan, StarRating as StarRatingType } from "../@types";
import { getOriginalMedicareStarRatings } from "../api";
import { AppStore } from "../app/store";
import { getStarRating, useTranslate } from "../helpers";
import HelpDrawerWrapper from "./HelpDrawerWrapper";
import ScrollTable from "./ScrollTable";
import StarRating from "./StarRating";

interface OriginalMedicareStarRatingsProps {
  plan: Plan;
}

const OriginalMedicareStarRatings: React.FunctionComponent<OriginalMedicareStarRatingsProps> = ({
  plan,
}) => {
  const t = useTranslate();
  const {
    state: { fips, year },
  } = useContext(AppStore.AppContext);
  const [ratings, setRatings] = useState<StarRatingType[]>([]);
  const [error, setError] = useState("");

  async function fetchStarRatings(): Promise<void> {
    if (fips && year) {
      try {
        const omRatings = await getOriginalMedicareStarRatings(fips, year);
        if (omRatings.length) {
          setRatings(omRatings);
        } else {
          setError(t("om_stars.error_message"));
        }
      } catch (e) {
        setError(t("om_stars.error_message"));
      }
    }
  }

  useEffect(() => {
    fetchStarRatings();
  }, [fips, year]);

  return (
    <HelpDrawerWrapper
      toggleText={t("om_stars.view_how_plan_compares")}
      drawerTitle={t("om_stars.view_how_plan_compares")}
      tealiumProps={{
        callingLabel: "Plan Details",
        label: "Original Medicare Star Ratings",
      }}
      large
      toggleClassName="OriginalMedicareStarRatingsToggle"
    >
      {error ? (
        <p>{error}</p>
      ) : (
        <ScrollTable className="OriginalMedicareStarRatingsTable">
          <thead>
            <tr>
              <th>{t("om_stars.category_column_heading")}</th>
              <th>{t("om_stars.star_column_heading")}</th>
              <th>{t("om_stars.plan_star_column_heading")}</th>
            </tr>
          </thead>
          <tbody>
            {ratings.map(rating => {
              return (
                <tr key={rating.category}>
                  <td>{t(`om_stars.${rating.category.toLowerCase()}`)}</td>
                  <td>
                    <StarRating
                      stars={rating}
                      includeLabel={false}
                      planYear={year || ""}
                    />
                  </td>
                  <td>
                    <StarRating
                      stars={getStarRating(plan, rating.category)}
                      includeLabel={false}
                      planYear={plan.contract_year}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </ScrollTable>
      )}
    </HelpDrawerWrapper>
  );
};

export default OriginalMedicareStarRatings;
